import { ActionTypes as actions } from '../actions';

const initialState = {
  notificationsDict: null,     // Key Value object where keys are _id  of notifications
  notificationsTypeDict: null, // Key Value object where keys are type of notifications
  notificationsConsultationsDict: null, // Key Value object where keys are consultation_id and value is true or false
  notificationsSocketSet: false,
}

export default function NotificationsReducer(state=initialState, action) {

  switch(action.type) {
    case actions.NOTIFICATIONS_UPDATE_DICT:
      state = { ...state, notificationsDict: action.payload };
      break;
    case actions.NOTIFICATIONS_UPDATE_TYPE_DICT:
      state = { ...state, notificationsTypeDict: action.payload };
      break;
    case actions.NOTIFICATIONS_UPDATE_CONSULTATIONS_DICT:
      state = { ...state, notificationsConsultationsDict: action.payload };
      break;
    case actions.NOTIFICATIONS_UPDATE_CONSULTATIONS_SOCKET:
      state = { ...state, notificationsSocketSet: action.payload };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
